import EventBase from "./EventBase";
import EventID from "./EventID";

class EventAddItem extends EventBase {
  public Code: EventID  = EventID.AddItem

  /**
   * 添加项显示内容
   */
  public Content: string = ''

  constructor(content: string = '>', indent: number = 0) {
    super()
    this.Parameter = [content]
    this.Indent = indent
  }
}
export default EventAddItem